import autoClearTimer from './auto-clear-timer';

const scanScreen = {
  props: {
    screenName: String,
    screenInfo: String,
    altInfo: String,
    canSkip: {
      type: Boolean,
      default: true,
    },
    canLeave: {
      type: Boolean,
      default: true,
    },
    blank: Boolean,
    error: Boolean,
    showIntro: Boolean,
    introDuration: {
      type: Number,
      default: 1.5,
    },
    introText: String,
    skipText: String,
    noPadding: Boolean,
    centerTitles: Boolean,
    step: Number,
    purpleTitle: Boolean,
    scrollable: Boolean,
  },
  mixins: [autoClearTimer],
  watch: {
    showIntro: {
      handler(nv, ov) {
        if (!ov && nv) {
          this.setAutoClearTimer(() => {
            this.$emit('update:showIntro', false);
          }, this.introDuration * 1000);
        }
      },
      immediate: true,
    },
  },
};

export default scanScreen;
